<template>
  <div class="pair_24g_page new_background-main" v-if="isShow42GPair">
    <div class="pair_24g_content">
      <!-- <div class="device">
                <img src="../../assets/img/device/he6_ultra/he6_ultra_bg.png">
            </div> -->
      <div class="notice_box">
        <div class="notice_title">{{ $t('pair_steps') }}</div>
        <div>{{ $t('pair_24g_notice1') }}</div>
        <div>{{ $t('pair_24g_notice2') }}</div>
        <div>{{ $t('pair_24g_notice3') }}</div>
        <!-- <div>{{ $t("pair_24g_notice4") }}</div> -->

        <div class="button_box">
          <div class="button pair_button" @click="pair">{{ resultMap.get(result)?.stateName }}</div>
          <div class="res_desc">{{ resultMap.get(result)?.stateDesc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export const isShow42GPair = ref(false)
export const isShowPairButton = ref(false)
</script>
<script lang="ts" setup>
import { DriverService } from '@/service/driver/driver'
import { CompxPairResult } from '@libs/types/enum'
import { DriverSocketMsgType } from '@libs/types/message'
import { ref, watch } from 'vue'
import i18n from '@/languages/i18n'
import { enableDialog } from '../cdialog/dialog'

const { t } = i18n.global

const result = ref(CompxPairResult.None)

interface PairResult {
  stateName: string
  stateDesc: string
}
const resultMap = new Map<number, PairResult>([
  [0, { stateName: t('start_pair'), stateDesc: t('start_pair_desc') }],
  [1, { stateName: t('pairing'), stateDesc: t('pairing_desc') }],
  [3, { stateName: t('pair_success'), stateDesc: t('pair_success_desc') }],
])

const pair = () => {
  if (result.value == CompxPairResult.None || result.value == CompxPairResult.Fail) {
    result.value = CompxPairResult.Pairing
    DriverService.instance.askType<number>(DriverSocketMsgType.MTPair24G).then((res) => {
      if (res == CompxPairResult.Fail) {
        result.value = CompxPairResult.Fail
        enableDialog(t('pair_fail'))
      } else if (res == CompxPairResult.Success) {
        isShow42GPair.value = false
        isShowPairButton.value = false
        result.value = CompxPairResult.None
      }
    })
  }
}

watch(isShow42GPair, (val) => {
  if (val) {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.code === 'Space') {
        pair()
        event.preventDefault()
      }
    })
  } else {
    document.removeEventListener('keydown', (_event: KeyboardEvent) => {})
  }
})
</script>

<style lang="less" scoped>
.pair_24g_page {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  background-size: auto 100%;
  z-index: 1;

  .pair_24g_content {
    display: flex;
    width: 920px;
    margin: 0 auto;
    margin-top: 120px;

    .device {
      margin-right: 30px;
    }

    .notice_box {
      color: #ffffff;
      font-size: 20px;
      line-height: 2.5;

      .notice_title {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .button_box {
        width: 920px;
        position: absolute;
        bottom: 150px;
        display: flex;
        flex-flow: column;
        align-items: center;

        .pair_button {
          width: 151px;
          height: 58px;
          border-radius: 4px;
          background: #fff;
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
          color: var(--color-brand-1);
          font-size: 22px;
        }

        .res_desc {
          margin-top: 24px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
